var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialogVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#f4f4f4;}.d{fill:silver;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 192,
    height: 192,
    transform: "translate(596 292)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-596 -292)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.903 288.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M136.249,97.542h-86.7a9.29,9.29,0,0,0-9.29,9.29v58.123H145.538V106.831A9.29,9.29,0,0,0,136.249,97.542Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M40.255,178.052a9.29,9.29,0,0,0,9.29,9.29h86.7a9.29,9.29,0,0,0,9.29-9.29v-6.905H40.255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M180.548,104.137l-25.906,16.189a6.193,6.193,0,0,0-2.911,5.264v33.715a6.193,6.193,0,0,0,2.911,5.264l26.228,16.393a9.29,9.29,0,0,0,14.213-8.361V111.811a9.29,9.29,0,0,0-14.535-7.673Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.635,10.838H12.386a9.29,9.29,0,0,0-9.29,9.29V155.664a9.29,9.29,0,0,0,9.29,9.29H148.635a9.29,9.29,0,0,0,9.29-9.29V20.128A9.29,9.29,0,0,0,148.635,10.838ZM83.607,17.031h30.966V48H83.607Zm-37.159,0H77.414V48H46.448ZM9.29,20.128a3.1,3.1,0,0,1,3.1-3.1H40.255V48H9.29ZM40.255,158.761H12.386a3.1,3.1,0,0,1-3.1-3.1V127.8H40.255Zm37.159,0H46.448V127.8H77.414Zm37.159,0H83.607V127.8h30.966Zm37.159-3.1a3.1,3.1,0,0,1-3.1,3.1H120.766V127.8h30.966Zm0-34.062H9.29V54.19H151.732Zm0-73.605H120.766V17.031h27.869a3.1,3.1,0,0,1,3.1,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M100.288,85.214,63.829,64.158a3.1,3.1,0,0,0-4.645,2.682v42.113a3.1,3.1,0,0,0,4.645,2.682l36.459-21.057a3.1,3.1,0,0,0,0-5.363ZM65.378,103.583V72.212L92.547,87.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogVideo);
export default __webpack_public_path__ + "static/media/dialog-video.1aa1eaa8263f8f54eb24073f74bc27fb.svg";
export { ForwardRef as ReactComponent };